import { jsx as t } from "react/jsx-runtime";
import { getTimeAgoString as P } from "../../../../services/time/index.js";
import { ParentContainer as d, ParentCommentContent as s } from "./style.js";
import { ParentCommentHeader as g } from "./components/ParentCommentHeader/index.js";
import { ParentcommentBodyContent as l } from "./components/ParentCommentBodyContent/index.js";
import { useTranslationContext as u } from "../../../../contexts/TranslationProvider/context.js";
function A({
  id: n,
  timestamp: r,
  author: e,
  profileURL: m,
  content: a,
  isDeleted: o,
  isAuthorVerified: i,
  className: f,
  clickoutFunction: c
}) {
  const { locale: p } = u(), C = P(
    new Date(r || ""),
    p || ""
  );
  return /* @__PURE__ */ t(d, { className: f, id: n, children: /* @__PURE__ */ t(
    s,
    {
      header: /* @__PURE__ */ t(
        g,
        {
          author: e,
          formattedTime: C,
          profileURL: m,
          isDeleted: o,
          isAuthorVerified: i
        }
      ),
      content: /* @__PURE__ */ t(
        l,
        {
          content: a,
          clickoutFunction: c,
          isDeleted: o
        }
      )
    }
  ) });
}
export {
  A as ParentComment
};
